var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.865,
    height: 12.865,
    viewBox: "0 0 12.865 12.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-minimalistic-svgrepo-com",
    transform: "translate(0.3 0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9913",
    "data-name": "Path 9913",
    d: "M10.586,2.4a.472.472,0,0,0-.7,0L7.374,5.155a.472.472,0,0,0,.7.637l1.7-1.855V10.9a.472.472,0,1,0,.943,0V3.937l1.7,1.855a.472.472,0,1,0,.7-.637Z",
    transform: "translate(-4.105 -2.25)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9914",
    "data-name": "Path 9914",
    d: "M3.193,14.722a.472.472,0,1,0-.943,0v.035a17.245,17.245,0,0,0,.073,2.1,2.338,2.338,0,0,0,.618,1.421,2.338,2.338,0,0,0,1.421.618,17.255,17.255,0,0,0,2.1.073H10.3a17.256,17.256,0,0,0,2.1-.073,2.338,2.338,0,0,0,1.421-.618,2.338,2.338,0,0,0,.618-1.421,17.256,17.256,0,0,0,.073-2.1v-.035a.472.472,0,1,0-.943,0,16.906,16.906,0,0,1-.065,2.008,1.418,1.418,0,0,1-.35.88,1.418,1.418,0,0,1-.88.35,16.906,16.906,0,0,1-2.008.065H6.5a16.905,16.905,0,0,1-2.008-.065,1.418,1.418,0,0,1-.88-.35,1.418,1.418,0,0,1-.35-.88A16.9,16.9,0,0,1,3.193,14.722Z",
    transform: "translate(-2.25 -6.702)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4d6a92d9db6e192e84d9115613e3ff5c.svg";
export { ForwardRef as ReactComponent };